
import Vue from "vue";
import {Component} from "vue-property-decorator";

@Component({})
export default class Announcer extends Vue {
    announcements: string[] = [];
    timeout = null;

    announce(text: string) {
        this.announcements.push(text);
        setTimeout(() => this.announcements.shift(), 5000);
    }
}
